import React from "react";
import ImagePrepare from "@elements/imagePrepare";
import { IGiftFinderQuestionOption } from "@types";

interface Props {
    options: IGiftFinderQuestionOption[];
    value: any[];
    isMulti: boolean;
    onChange: (value: any[]) => void;
}

const ImageSelection: React.FC<Props> = ({ options, value, isMulti, onChange }) => {
    const selected = Array.isArray(value) ? value : [];

    const handleClick = (id: number) => {
        if (isMulti) {
            if (selected.includes(id)) {
                onChange(selected.filter((item) => item !== id));
            } else {
                onChange([...selected, id]);
            }
            return;
        }

        onChange([id]);
    };

    return (
        <div className="grid grid-cols-2 gap-4">
            {options.map((option) => {
                const isSelected = selected.includes(option.id);
                const imageUrl = option.option_data;
                return (
                    <button
                        key={option.id}
                        type="button"
                        aria-pressed={isSelected}
                        aria-label={`gift-finder-option-${option.id}`}
                        onClick={() => handleClick(option.id)}
                        className={`relative rounded-xl overflow-hidden border-2 transition-all duration-200 ${
                            isSelected
                                ? "border-button-primary"
                                : "border-gray-200 hover:border-button-primary"
                        }`}
                    >
                        <div className="w-full aspect-[1.4/1] relative bg-gray-100">
                            <div className="absolute inset-0">
                                <ImagePrepare
                                    media={{ url: imageUrl, type: "image" }}
                                    alt={'gift-finder-option'}
                                />
                            </div>
                        </div>
                        {isSelected && (
                            <div className="absolute top-2 right-2 w-6 h-6 rounded-full bg-button-primary text-white text-sm font-bold flex items-center justify-center">
                                ✓
                            </div>
                        )}
                    </button>
                );
            })}
        </div>
    );
};

export default React.memo(ImageSelection);
